<template>
    <div class="container text-center">
        <h1>Contact</h1>
        <p class="lead">Email us at
            <a :href="email_url">{{ email }}</a>
        </p>
    </div>
</template>

<script>
import { config } from 'website-core'

export default {
    data() {
        return {
            email: config.email,
            email_url: 'mailto:' + config.email,
        }
    },
}
</script>